<ag-grid-angular
  [rowData]="rowData$ | async"
  [columnDefs]="columnDefs$ | async"
  [defaultColDef]="defaultColumnDef$ | async"
  [gridOptions]="gridOptions"
  [loading]="loading$ | async"
  [suppressContextMenu]="true"
  [multiSortKey]="'ctrl'"
  (gridReady)="onGridReady()"
  class="ag-theme-alpine_customize"></ag-grid-angular>
